import { Routes, Route } from "react-router-dom";
import Layout from './contents/layout/Layout';

function AppRoutes() {
  return (
    <Routes>
        <Route path="/*" element={<Layout />} />
    </Routes>
  );
}

export default AppRoutes;
